module.exports = __webpack_public_path__ + "media/images/games/k2reveal/bike-5905a311f44b2f492de7546a6e722ff1.png";